import { observer } from 'mobx-react-lite'
import { Button, Icon } from 'shared/ui'
import { LINK_SALESMSG_MCP_GUIDE } from 'shared/constants/links'
import { uiStore } from 'shared/store/uiStore'
import { IntegrationKey } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import styles from './styles.module.scss'

export const AnalyzeWithAiButton = observer(() => {
  const { userPermissionsStore, subscriptionStore } = useEntitiesContext()
  const canManageIntegrations = userPermissionsStore.can_manage_integrations
  const { isCanceled } = subscriptionStore
  const isDisabled = !canManageIntegrations || isCanceled

  const tooltipLabel = isDisabled ? (
    <>
      An AI assistant can be connected to Salesmsg and asked questions about this analytics data.
      <br />
      <br />
      The App Marketplace is unavailable while the subscription is cancelled. A workspace Owner or
      Admin can enable it.
    </>
  ) : (
    'Connect an AI assistant to Salesmsg and ask it questions about this analytics data — trends, comparisons, follow-up questions.'
  )

  return (
    <Button
      text={'Analyze with AI'}
      icon={'stars'}
      iconProps={{ color: 'var(--purple-70)' }}
      typeBtn={'outlined'}
      contained={'secondary'}
      disabled={isDisabled}
      onClick={() => {
        uiStore.changeRoute({ path: `settings/integrations/${IntegrationKey.salesmsg_mcp}` })
      }}
      className={styles.button}
      textClassname={styles.text}
      tooltipProps={{
        width: 185,
        type: 'description',
        desc: (
          <div className={styles.tooltipContent}>
            {tooltipLabel}
            <a
              className={styles.tooltipLink}
              href={LINK_SALESMSG_MCP_GUIDE}
              target={'_blank'}
              rel={'noreferrer'}
            >
              <Icon icon={'info'} fontSize={12} />
              Help guide
            </a>
          </div>
        ),
      }}
    />
  )
})
